import axios from 'axios';
import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

export const getAuthHistory = async ({ from, to }) => {
  return axios({
    method: 'get',
    url: endpoints.AuthHistory.REPORT,
    baseURL: baseUrl,
    params: { from, to },
  });
};
